export class LoginDTO {
	entidad: string;
	user: string;
	password: string;
	error: string;

	constructor() {
    	
    }
}


// WEBPACK FOOTER //
// C:/Users/adri9/Escritorio/admin-everpath/src/app/domain/dto/loginDto.ts